import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminHeader from "../../common/AdminHeader";
import { Modal, Button, Form } from "react-bootstrap";
import Footer from "../../common/Footer";
import { baseUrl } from "../../../Utility/constants";

const MotherTongue = () => {
  const [motherTongues, setMotherTongues] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formState, setFormState] = useState({
    id: 0,
    name: "",
  });
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    fetchMotherTongues();
  }, []);

  const fetchMotherTongues = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/MotherTongueMaster`);
      setMotherTongues(response.data);
    } catch (error) {
      toast.error("Failed to fetch Mother Tongues.");
    }
  };

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setFormState({ id: 0, name: "" });
    setEditMode(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState({ ...formState, [name]: value });
  };

  const handleEdit = (motherTongue) => {
    setFormState(motherTongue);
    setEditMode(true);
    handleShowModal();
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this Mother Tongue?")) {
      try {
        await axios.delete(`${baseUrl}/api/MotherTongueMaster/${id}`);
        toast.success("Mother Tongue deleted successfully.");
        fetchMotherTongues();
      } catch (error) {
        toast.error("Failed to delete Mother Tongue.");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editMode) {
        await axios.put(`${baseUrl}/api/MotherTongueMaster/${formState.id}`, formState);
        toast.success("Mother Tongue updated successfully.");
      } else {
        await axios.post(`${baseUrl}/api/MotherTongueMaster`, formState);
        toast.success("Mother Tongue added successfully.");
      }
      fetchMotherTongues();
      handleCloseModal();
    } catch (error) {
      toast.error("Failed to save Mother Tongue.");
    }
  };

  return (
    <>
      <AdminHeader />
      <div className="container mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Mother Tongue</h2>
          <Button variant="primary" onClick={handleShowModal}>
            Add Mother Tongue
          </Button>
        </div>

        <table className="table table-bordered">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {motherTongues.map((motherTongue) => (
              <tr key={motherTongue.id}>
                <td>{motherTongue.id}</td>
                <td>{motherTongue.name}</td>
                <td>
                  <Button variant="warning" onClick={() => handleEdit(motherTongue)}>
                    Edit
                  </Button>{" "}
                  <Button variant="danger" onClick={() => handleDelete(motherTongue.id)}>
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{editMode ? "Edit Mother Tongue" : "Add Mother Tongue"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group>
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formState.name}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="mt-3">
              {editMode ? "Update" : "Add"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <ToastContainer />

      <Footer />
    </>
  );
};

export default MotherTongue;
